<style scoped>
.right-last-block {
    width: inherit;
    float: left;
    margin-left: 100px;
    margin-right: 800px;
    margin-top: 10px;
}
.collection-date {
    margin-right: 10px;
}
.left-content {
    margin: auto;
}
.refresh {
    width: inherit;
}
.right-block {
    width: inherit;
    float: left;
    margin-left: 60px;
    margin-top: 10px;
}
.block {
    font-size: 14px;
    float: left;
    margin-right: 15px;
    line-height: 40px;
}
.el-dropdown-link {
    cursor: pointer;
}
.el-icon-arrow-down {
    font-size: 12px;
    padding-left: 20px;
}
.but-stye {
    width: 95%;
}
.containr {
    background-color: white;
    width: 1200px;
    display: flex;
    margin: 10px auto 30px;
}
.main {
}

.left {
    background-color: white;
    width: 300px;
    margin-right: 20px;
}
.right {
    background-color: white;
    width: 900px;
}

.right-first-two {
    background-color: rgb(243, 244, 246);
    height: 100px;
}

.right-first-four {
    background-color: rgb(243, 244, 246);
    height: 60px;
}

.right-first-three {
    background-color: rgb(243, 244, 246);
    height: 390px;
}

.right-second {
    font-size: 14px;
    margin-top: 20px;
}

.left-title {
    background-color: rgb(187, 187, 187);
    height: 50px;
    margin: auto;
}
.right-title {
    background-color: rgb(187, 187, 187);
    height: 50px;
    margin: auto;
}
.but-refresh {
    float: left;
    margin-left: 79px;
}
.but-refreshTwo {
    margin-top: 5px;
    float: left;
    margin-left: 64px;
}

.but-search {
    float: left;
    margin-left: 10px;
}
.left-title-text {
    font-size: 14px;
    margin-left: 25px;
    line-height: 45px;
}
.right-title-text {
    margin-left: 30px;
    font-size: 14px;
    line-height: 45px;
}

.el-tree-node .el-tree-node__content {
    background-color: #ffffff;
    height: 40px;
    line-height: 40px;
    border: 1px solid #f0f0f0;
}

.el-tree-node span {
    font-weight: bold;
}

.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
.conditionList {
    margin-left: 79px;
}
.banner-top {
    width: 100%;
    height: 100px;
    margin-top: 50px;
    line-height: 100px;
    background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
    width: 1200px;
    margin: 0 auto;
}
.banner-desc {
    text-align: center;
    font-size: 14px;
    color: #ffffff;
}
.el-tree-node.is-current > .el-tree-node__content {
    background-color: red !important;
}
</style>
<template>
    <div class="main">
        <div class="banner-top">
            <div class="banner-box"></div>
            <div class="banner-desc">对大行研报的各类标签进行系统性分类，构建专业的研报大数据平台，支持海量研报快速查找阅读。</div>
        </div>
        <div class="containr">
            <div class="left">
                <div class="left-title">
                    <span class="left-title-text">投研库</span>
                </div>
                <div class="left-content">
                    <el-tree :data="leftListData" ref="tree" node-key="treeNodeId" :highlight-current="true" :props="leftDefaultProps" @node-click="handleNodeClick" style="  background-color: rgb(243, 244, 246);"></el-tree>
                </div>
            </div>

            <div class="right">
                <div class="right-title">
                    <span class="right-title-text">查询</span>
                </div>

                <div style=" background-color: rgb(243, 244, 246); height: 140px;" v-if="arrSearchConditionOne.includes(currentCatid)">
                    <div class="right-block">
                        <div class="block">收录日期</div>
                        <div class="block">
                            <el-select v-model="collectionDateRange" style=" width: 202px" placeholder="请选择">
                                <el-option v-for="item in researchReportCollectionDateRanges" :key="item.collectionDateRange" :label="item.collectionDateRangeLabel" :value="item.collectionDateRange">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="block">股票代码</div>
                        <div class="block">
                            <el-input v-model="stockCodeCondition" placeholder="请输入内容"></el-input>
                        </div>
                        <br><br>
                        <div class="block">股票名称</div>
                        <div class="block">
                            <el-input v-model="stockNameCondition" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                    <br><br><br><br><br><br>
                    <div class="block" style="margin-left: 60px;">研报评级</div>
                    <div class="block">
                        <el-select v-model="researchReportRatingsValue" style=" width: 202px" placeholder="请选择">
                            <el-option v-for="item in researchReportRatings" :key="item.researchReportRatingsValue" :label="item.researchReportRatingsLabel" :value="item.researchReportRatingsValue">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="block">研报作者</div>
                    <div class="block">
                        <el-input v-model="researchReportAuthor" placeholder="请输入内容"></el-input>
                    </div>
                    <div style="float:left;">
                        <el-button class="but-stye" @click="onRefresh()">刷新</el-button>
                    </div>
                    <div style="float:left; ">
                        <el-button class="but-stye" @click="onSearch()" style="background:rgb(72 131 255); color:aliceblue;">搜索</el-button>
                    </div>
                </div>

                <div class="right-first-four" v-if="arrSearchConditionThree.includes(currentCatid)">
                    <div class="right-block">

                        <div class="block">撰写日期</div>
                        <div class="block">
                            <el-date-picker v-model="dateRangeCondition" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div class="but-refresh">
                            <el-button class="but-stye" @click="onRefresh()">刷新</el-button>
                        </div>
                        <div class="but-search">
                            <el-button class="but-stye" @click="onSearch()" style="background:rgb(72 131 255); color:aliceblue;">搜索</el-button>
                        </div>
                    </div>
                </div>

                <div class="right-first-two" v-if="apiType == 1 || apiType == 3 || apiType == 4">
                    <div class="right-block">
                        <div class="block">关键词</div>
                        <div class="block">
                            <el-input v-model="keywordCondition" placeholder="请输入股票名称或代码"></el-input>
                        </div>
                        <div class="block">日期</div>
                        <div class="block">
                            <el-date-picker v-model="dateRangeCondition" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <br>
                        <div class="but-refreshTwo">
                            <el-button class="but-stye" @click="onRefresh()">刷新</el-button>
                        </div>
                        <div class="block" style="margin-top: 5px;">
                            <el-button class="but-stye" @click="onSearch()" style="background:rgb(72 131 255); color:aliceblue;">搜索</el-button>
                        </div>
                    </div>
                </div>

                <div class="right-first-two" v-if="arrSearchConditionFour.includes(currentCatid) || arrSearchConditionFive.includes(currentCatid)">
                    <div class="right-block">
                        <div class="block">查询时间</div>
                        <div class="block">
                            <el-select v-model="collectionDateRange" style=" width: 202px" placeholder="请选择">
                                <el-option v-for="item in researchReportCollectionDateRangesTemp" :key="item.collectionDateRange" :label="item.collectionDateRangeLabel" :value="item.collectionDateRange">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="but-refresh">
                            <el-button class="but-stye" @click="onRefresh()">刷新</el-button>
                        </div>
                        <div class="but-search">
                            <el-button class="but-stye" @click="onSearch()" style="background:rgb(72 131 255); color:aliceblue;">搜索</el-button>
                        </div>
                    </div>
                </div>

                <div style="height: 180px;  background-color: rgb(243, 244, 246);" v-if="arrSearchConditionSix.includes(currentCatid)">
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 0px 20px 10px 20px;">
                        <div style="margin: 10px 20px 0 0;font-size: 14px">撰写日期</div>
                        <div style="margin: 10px 20px 0 0;">
                            <el-date-picker style="width: 300px;" v-model="dateRangeCondition" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div style="margin: 10px 20px 0 0;font-size: 14px">研报标题</div>
                        <div style="margin: 10px 20px 0 0;   width: 345px;">
                            <el-input v-model="researchReportTitle" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 20px 10px 20px;">
                        <div style="margin-right: 20px;font-size: 14px">研报机构</div>
                        <div style=" margin-right: 20px;   width: 180px;">
                            <el-input v-model="researchReportInstitution" placeholder="请输入内容"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">研报作者</div>
                        <div style=" margin-right: 20px;   width: 180px;">
                            <el-input v-model="researchReportAuthor" placeholder="请输入内容"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">股票代码</div>
                        <div style=" margin-right: 20px;   width: 180px;">
                            <el-input v-model="stockCodeCondition" placeholder="请输入股票代码"></el-input>
                        </div>
                    </div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 20px 10px 20px;">
                        <div style="margin-right: 20px;font-size: 14px">股票名称</div>
                        <div style="margin-right: 20px; width: 180px;">
                            <el-input v-model="stockNameCondition" placeholder="请输入股票名称"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">研报评级</div>
                        <div style="margin-right: 20px;">
                            <el-select v-model="researchReportRatingsValue" style=" width: 180px" placeholder="请选择">
                                <el-option v-for="item in researchReportRatings" :key="item.researchReportRatingsValue" :label="item.researchReportRatingsLabel" :value="item.researchReportRatingsValue">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="but-refresh">
                            <el-button class="but-stye" @click="onRefresh()">刷新</el-button>
                        </div>
                        <div class="but-search">
                            <el-button class="but-stye" @click="onSearch()" style="background:rgb(72 131 255); color:aliceblue;">搜索</el-button>
                        </div>
                    </div>
                </div>

                <div style="height: 460px;  background-color: rgb(243, 244, 246);" v-if="arrSearchConditionTwo.includes(currentCatid)">
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 0 20px 10px 20px;">
                        <div style="margin: 10px 20px 0 0;font-size: 14px">撰写日期</div>
                        <div style="margin: 10px 20px 0 0;">
                            <el-date-picker style="width: 230px;" v-model="dateRangeCondition" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div style="margin: 10px 20px 0 0;font-size: 14px">研报标题</div>
                        <div style="margin: 10px 20px 0 0;   width: 405px;">
                            <el-input v-model="researchReportTitle" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 20px 10px 20px;">
                        <div style="margin-right: 20px;font-size: 14px">研报机构</div>
                        <div style=" margin-right: 20px;   width: 230px;">
                            <el-input v-model="researchReportInstitution" placeholder="请输入内容"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">研报作者</div>
                        <div style=" margin-right: 20px;   width: 150px;">
                            <el-input v-model="researchReportAuthor" placeholder="请输入内容"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">股票代码</div>
                        <div style=" margin-right: 20px;   width: 150px;">
                            <el-input v-model="stockCodeCondition" placeholder="请输入股票代码"></el-input>
                        </div>
                    </div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 20px 10px 20px;">
                        <div style="margin-right: 20px;font-size: 14px">股票名称</div>
                        <div style="margin-right: 20px; width: 230px;">
                            <el-input v-model="stockNameCondition" placeholder="请输入股票名称"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">研报评级</div>
                        <div style="margin-right: 20px;">
                            <el-select v-model="researchReportRatingsValue" style=" width: 150px" placeholder="请选择">
                                <el-option v-for="item in researchReportRatings" :key="item.researchReportRatingsValue" :label="item.researchReportRatingsLabel" :value="item.researchReportRatingsValue">
                                </el-option>
                            </el-select>
                        </div>
                    </div>

                    <div style="margin: 10px 20px 10px 20px;font-size: 14px">所属行业</div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 0 10px 20px;">
                        <el-radio-group v-model="industryCondition">
                            <el-radio-button label="">不限</el-radio-button>
                            <el-radio-button disabled>B</el-radio-button>
                            <el-radio-button label="C78">玻璃陶瓷</el-radio-button>
                            <el-radio-button disabled>D</el-radio-button>
                            <el-radio-button label="C105">电力行业</el-radio-button>
                            <el-radio-button label="C123">电子信息</el-radio-button>
                            <el-radio-button disabled>F</el-radio-button>
                            <el-radio-button label="C139">房地产业</el-radio-button>
                            <el-radio-button label="C65">纺织行业</el-radio-button>
                            <el-radio-button disabled>G</el-radio-button>
                            <el-radio-button label="C59">钢铁行业</el-radio-button>
                            <el-radio-button label="C107">供水供气</el-radio-button>
                            <el-radio-button disabled>H</el-radio-button>
                            <el-radio-button label="C102">航空工业</el-radio-button>
                            <el-radio-button label="C72">化工行业</el-radio-button>
                            <el-radio-button label="C74">化纤行业</el-radio-button>
                            <el-radio-button label="C89">环保节能</el-radio-button>
                            <el-radio-button disabled>J</el-radio-button>
                            <el-radio-button label="C91">机械行业</el-radio-button>
                            <el-radio-button label="C1146">家电行业</el-radio-button>
                            <el-radio-button label="C113">建筑建材</el-radio-button>
                            <el-radio-button label="C103">交通运输</el-radio-button>
                            <el-radio-button label="C134">金融行业</el-radio-button>
                            <el-radio-button label="C141">酒店旅游</el-radio-button>
                            <el-radio-button disabled>M</el-radio-button>
                            <el-radio-button label="C58">煤炭开采</el-radio-button>
                            <el-radio-button disabled>N</el-radio-button>
                            <el-radio-button label="C64">酿酒行业</el-radio-button>
                            <el-radio-button label="C53">农林牧渔</el-radio-button>
                            <el-radio-button label="C73">农药化肥</el-radio-button>
                            <el-radio-button disabled>S</el-radio-button>
                            <el-radio-button label="C129">商业贸易</el-radio-button>
                            <el-radio-button label="C87">生物医药</el-radio-button>
                            <el-radio-button label="C71">石油行业</el-radio-button>
                            <el-radio-button label="C63">食品饮料</el-radio-button>
                            <el-radio-button label="C77">水泥行业</el-radio-button>
                            <el-radio-button disabled>W</el-radio-button>
                            <el-radio-button label="C145">文化传媒</el-radio-button>
                            <el-radio-button disabled>Y</el-radio-button>
                            <el-radio-button label="C70">印刷包装</el-radio-button>
                            <el-radio-button label="C61">有色行业</el-radio-button>
                            <el-radio-button disabled>Z</el-radio-button>
                            <el-radio-button label="C69">造纸行业</el-radio-button>
                            <el-radio-button label="C146">综合类</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 0px 10px 630px;">
                        <div class="but-refresh">
                            <el-button class="but-stye" @click="onRefresh()">刷新</el-button>
                        </div>
                        <div class="but-search">
                            <el-button class="but-stye" @click="onSearch()" style="background:rgb(72 131 255); color:aliceblue;">搜索</el-button>
                        </div>
                    </div>
                </div>

                <div style="height: 400px;  background-color: rgb(243, 244, 246);" v-if="arrSearchConditionSeven.includes(currentCatid)">
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 0px 20px 10px 20px;">
                        <div style="margin: 10px 20px 0 0;font-size: 14px">撰写日期</div>
                        <div style="margin: 10px 20px 0 0;">
                            <el-date-picker style="width: 230px;" v-model="dateRangeCondition" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div style="margin: 10px 20px 0 0;font-size: 14px">研报标题</div>
                        <div style="margin: 10px 20px 0 0;width: 405px;">
                            <el-input v-model="researchReportTitle" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 20px 10px 20px;">
                        <div style="margin-right: 20px;font-size: 14px">研报机构</div>
                        <div style=" margin-right: 20px;   width: 230px;">
                            <el-input v-model="researchReportInstitution" placeholder="请输入内容"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">研报作者</div>
                        <div style=" margin-right: 20px;   width: 150px;">
                            <el-input v-model="researchReportAuthor" placeholder="请输入内容"></el-input>
                        </div>
                        <div style="margin-right: 20px;font-size: 14px">研报评级</div>
                        <div style="margin-right: 20px;">
                            <el-select v-model="researchReportRatingsValue" style=" width: 150px" placeholder="请选择">
                                <el-option v-for="item in researchReportRatings" :key="item.researchReportRatingsValue" :label="item.researchReportRatingsLabel" :value="item.researchReportRatingsValue">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div style="margin: 10px 20px 10px 20px;font-size: 14px">所属行业</div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 0px 10px 20px;">
                        <el-radio-group v-model="industryCondition">
                            <el-radio-button label="">不限</el-radio-button>
                            <el-radio-button disabled>B</el-radio-button>
                            <el-radio-button label="C78">玻璃陶瓷</el-radio-button>
                            <el-radio-button disabled>D</el-radio-button>
                            <el-radio-button label="C105">电力行业</el-radio-button>
                            <el-radio-button label="C123">电子信息</el-radio-button>
                            <el-radio-button disabled>F</el-radio-button>
                            <el-radio-button label="C139">房地产业</el-radio-button>
                            <el-radio-button label="C65">纺织行业</el-radio-button>
                            <el-radio-button disabled>G</el-radio-button>
                            <el-radio-button label="C59">钢铁行业</el-radio-button>
                            <el-radio-button label="C107">供水供气</el-radio-button>
                            <el-radio-button disabled>H</el-radio-button>
                            <el-radio-button label="C102">航空工业</el-radio-button>
                            <el-radio-button label="C72">化工行业</el-radio-button>
                            <el-radio-button label="C74">化纤行业</el-radio-button>
                            <el-radio-button label="C89">环保节能</el-radio-button>
                            <el-radio-button disabled>J</el-radio-button>
                            <el-radio-button label="C91">机械行业</el-radio-button>
                            <el-radio-button label="C1146">家电行业</el-radio-button>
                            <el-radio-button label="C113">建筑建材</el-radio-button>
                            <el-radio-button label="C103">交通运输</el-radio-button>
                            <el-radio-button label="C134">金融行业</el-radio-button>
                            <el-radio-button label="C141">酒店旅游</el-radio-button>
                            <el-radio-button disabled>M</el-radio-button>
                            <el-radio-button label="C58">煤炭开采</el-radio-button>
                            <el-radio-button disabled>N</el-radio-button>
                            <el-radio-button label="C64">酿酒行业</el-radio-button>
                            <el-radio-button label="C53">农林牧渔</el-radio-button>
                            <el-radio-button label="C73">农药化肥</el-radio-button>
                            <el-radio-button disabled>S</el-radio-button>
                            <el-radio-button label="C129">商业贸易</el-radio-button>
                            <el-radio-button label="C87">生物医药</el-radio-button>
                            <el-radio-button label="C71">石油行业</el-radio-button>
                            <el-radio-button label="C63">食品饮料</el-radio-button>
                            <el-radio-button label="C77">水泥行业</el-radio-button>
                            <el-radio-button disabled>W</el-radio-button>
                            <el-radio-button label="C145">文化传媒</el-radio-button>
                            <el-radio-button disabled>Y</el-radio-button>
                            <el-radio-button label="C70">印刷包装</el-radio-button>
                            <el-radio-button label="C61">有色行业</el-radio-button>
                            <el-radio-button disabled>Z</el-radio-button>
                            <el-radio-button label="C69">造纸行业</el-radio-button>
                            <el-radio-button label="C146">综合类</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div style="display: flex;  flex-wrap: nowrap; line-height: 40px; margin: 10px 0px 10px 630px;">
                        <div class="but-refresh">
                            <el-button class="but-stye" @click="onRefresh()">刷新</el-button>
                        </div>
                        <div class="but-search">
                            <el-button class="but-stye" @click="onSearch()" style="background:rgb(72 131 255); color:aliceblue;">搜索</el-button>
                        </div>
                    </div>
                </div>
                <div class="right-second" v-if="tableDataTypeOne.includes(this.currentCatid)">
                    <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)" :data="tableData" style="width: 100%" :default-sort="{prop: 'collectionDate', order: 'descending'}" @cell-click="onCellClick">
                        <el-table-column prop="collectionDate" label="收录日期" sortable width="110">
                        </el-table-column>
                        <el-table-column prop="writingDate" label="撰写日期" sortable width="120">
                        </el-table-column>
                        <el-table-column prop="researchReportType" label="研报类型" width="120">
                        </el-table-column>
                        <el-table-column prop="researchReportTitle" label="研报标题" width="500">
                            <template slot-scope="scope">
                                <span style=" cursor: pointer; ">{{ scope.row.researchReportTitle }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="researchReportRatings" label="评级" sortable width="120">
                        </el-table-column>
                        <el-table-column prop="researchReportInstitution" label="研报机构" width="120">
                        </el-table-column>
                        <el-table-column prop="researchReportAuthor" label="研报作者">
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="parseInt(totalRows)">
                    </el-pagination>
                </div>

                <div class="right-second" v-if="apiType == 1  ">
                    <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)" :data="tableData" style="width: 100%" :default-sort="{prop: 'collectionDate', order: 'descending'}" @cell-click="onCellClick">
                        <el-table-column prop="researchReportType" label="栏目" width="180">
                        </el-table-column>
                        <el-table-column prop="researchReportTitle" label="标题" width="280">
                            <template slot-scope="scope">
                                <span style=" cursor: pointer; ">{{ scope.row.researchReportTitle }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="publishDate" label="发布时间" sortable>
                        </el-table-column>

                    </el-table>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="parseInt(totalRows)">
                    </el-pagination>
                </div>

                <div class="right-second" v-if="tableDataTypeTwo.includes(this.currentCatid)">
                    <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)" :data="tableData" style="width: 100%" :default-sort="{prop: 'collectionDate', order: 'descending'}" @cell-click="onCellClick">
                        <el-table-column prop="collectionDate" label="收录日期" sortable width="100">
                        </el-table-column>
                        <el-table-column prop="writingDate" label="撰写日期" sortable width="100">
                        </el-table-column>
                        <el-table-column prop="stockCode" label="股票代码" width="80">
                        </el-table-column>
                        <el-table-column prop="companyName" label="公司名称" width="120">
                        </el-table-column>
                        <el-table-column prop="researchReportTitle" label="研报标题" width="320">
                            <template slot-scope="scope">
                                <span style=" cursor: pointer; ">{{ scope.row.researchReportTitle }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="researchReportRatings" label="评级" sortable width="80">
                        </el-table-column>
                        <el-table-column prop="changeStatus" label="变动" width="80">
                        </el-table-column>
                        <el-table-column prop="expectedPrice" label="预期价" width="135">
                        </el-table-column>
                        <el-table-column prop="reportClosingPrice" label="报告收盘价" width="80">
                        </el-table-column>
                        <el-table-column prop="researchReportInstitution" label="研报机构" width="100">
                        </el-table-column>
                        <el-table-column prop="researchReportAuthor" label="研报作者">
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="parseInt(totalRows)">
                    </el-pagination>
                </div>

                <div class="right-second" v-if="arrSearchConditionFour.includes(this.currentCatid) ">
                    <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.02)" :data="tableData" style="width: 100%" :default-sort="{prop: 'stockIndex', order: 'ascending'}" @cell-click="onCellClick">
                        <el-table-column prop="stockIndex" label="排名" sortable width="80">
                        </el-table-column>
                        <el-table-column prop="OrganIDCount" label="机构数" sortable width="100">
                        </el-table-column>
                        <el-table-column prop="StockCount" label="研报数" width="80">
                        </el-table-column>
                        <el-table-column prop="StockCode" label="股票代码" width="100">
                        </el-table-column>
                        <el-table-column prop="StockName" label="公司名称" sortable width="160">
                        </el-table-column>
                        <el-table-column prop="MaxAimPrice" label="最高预期价" width="120">
                        </el-table-column>
                        <el-table-column prop="MinAimPrice" label="最低预期价" width="120">
                        </el-table-column>
                        <el-table-column prop="ClosePrice" label="收盘价" sortable width="120">
                        </el-table-column>
                        <el-table-column prop="reportlink" label="详细">
                            <template slot-scope="scope">
                                <span style=" cursor: pointer; " onclick=" this.goTOLocalLink(row)">{{ scope.row.reportlink }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="parseInt(totalRows)">
                    </el-pagination>
                </div>

                <div class="right-second" v-if="apiType == 6">
                    <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)" :data="tableData" style="width: 100%" :default-sort="{prop: 'stockIndex', order: 'ascending'}" @cell-click="onCellClick">
                        <el-table-column prop="StockCode" label="股票代码" width="100">
                        </el-table-column>
                        <el-table-column prop="StockName" label="公司名称" sortable width="160">
                        </el-table-column>
                        <el-table-column prop="MaxOriginGrade" label="最高评级" width="120">
                        </el-table-column>
                        <el-table-column prop="MinOriginGrade" label="最低评级" width="120">
                        </el-table-column>
                        <el-table-column prop="OrganIDCount" label="机构数" sortable width="100">
                        </el-table-column>
                        <el-table-column prop="MaxAimPrice" label="最高预期价" width="120">
                        </el-table-column>
                        <el-table-column prop="MinAimPrice" label="最低预期价" width="120">
                        </el-table-column>
                        <el-table-column prop="ClosePrice" label="收盘价" sortable width="120">
                        </el-table-column>
                        <el-table-column prop="reportlink" label="详细">
                            <template slot-scope="scope">
                                <span style=" cursor: pointer; " onclick=" this.goTOLocalLink(row)">{{ scope.row.reportlink }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="parseInt(totalRows)">
                    </el-pagination>
                </div>

                <div class="right-second" v-if="apiType == 7">
                    <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)" :data="tableData" style="width: 100%" :default-sort="{prop: 'stockIndex', order: 'ascending'}" @cell-click="onCellClick">
                        <el-table-column prop="OrganName" label="研究机构" sortable width="160">
                        </el-table-column>
                        <el-table-column prop="ContentCount" label="研报数" width="120">
                        </el-table-column>
                        <el-table-column prop="AuthorCount" label="研究人员数" sortable width="120">
                        </el-table-column>
                        <el-table-column prop="avgCount" label="人均研报数" width="120">
                        </el-table-column>
                        <el-table-column prop="StockCodeCount" label="个股篇数" sortable width="160">
                        </el-table-column>
                        <el-table-column prop="Count732" label="行业篇数" width="120">
                        </el-table-column>
                        <el-table-column prop="Count557" label="宏观篇数" width="120">
                        </el-table-column>
                        <el-table-column prop="Count559" label="策略篇数" width="120">
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="parseInt(totalRows)">
                    </el-pagination>
                </div>

                <div class="right-second" v-if="arrSecuritiesMicroLibrary.includes(this.currentCatid)">
                    <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)" :data="tableData" style="width: 100%" :default-sort="{prop: 'stockIndex', order: 'ascending'}" @cell-click="onCellClick">
                        <el-table-column prop="ClassName" label="栏目" width="160">
                        </el-table-column>
                        <el-table-column prop="Title" label="标题" width="500">
                            <template slot-scope="scope">
                                <span style=" cursor: pointer; ">{{ scope.row.Title }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="DisplayTime" label="发布时间" sortable>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="parseInt(totalRows)">
                    </el-pagination>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { BolanRole } from "@/api/user";
export default {

    name: "InvestmentResearchLibrary",
    mounted() {
        this.header_show = true;
        this.Authorization();
    },
    methods: {
        initByType() {
            let allNodes = this.$refs["tree"].store._getAllNodes();
            switch (this.$route.query.activeName) {
                case 'first': {
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/dhyb/getList?page=';
                    this.currentUrlfooter = '&limit=20&type=1&classId=';
                    this.currentCatid = 'C1263';
                    this.apiType = 2;
                    this.$refs.tree.setCurrentKey(0);
                    allNodes.forEach(node => {
                        if (node.data.treeNodeId == 0) {
                            node.expanded = true;
                        }
                    });
                };
                    break;
                case 'second': {
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/api/jrdbOnline?page=';
                    this.currentUrlfooter = '&limit=20&catid=';
                    this.currentCatid = 'C2812';
                    this.apiType = 1;
                    this.$refs.tree.setCurrentKey(1000);
                    allNodes.forEach(node => {
                        if (node.data.treeNodeId == 24) {
                            node.expanded = true;
                        }
                    });
                };
                    break;
                case 'third': {
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/api/zqwxList?page=';
                    this.currentUrlfooter = '&limit=20&zqcode=';
                    this.currentCatid = 'WX001';
                    this.apiType = 4;
                    this.$refs.tree.setCurrentKey(193);
                    allNodes.forEach(node => {
                        if (node.data.treeNodeId == 193 || node.data.treeNodeId == 192) {
                            node.expanded = true;
                        }
                    });
                };
                    break;
            };
        },
        onCellClick(row, column, cell, event) {
            if (column['label'] == '研报标题' || column['label'] == '标题') {
                this.onDetail(row)
            } else if (column['label'] == '详细' && row['reportlink'] == '报告链接') {
                this.goTOLocalLink(row);
            } else if (column['label'] == '标题' && this.apiType == 3 || this.apiType == 4) {
                this.onDetail(row)
            }
        },
        goTOLocalLink(row) {
            this.currentUrlHead = 'http://tg.bolanjr.com/api/dhyb/getList?page=';
            this.currentUrlfooter = '&limit=20&type=2&classId='
            this.currentPage = 1;
            this.currentCatid = 'C731';
            this.apiType = 2;
            this.serachCondition = '&stockCode=' + row['StockCode'];
            this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid + this.serachCondition, this.apiType);
        },
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid + this.serachCondition, this.apiType);
        },
        async Authorization() {
            BolanRole().then((response) => {
                if (response.code === 2000) {
                    if (response.data.includes('投研库')) {
                        this.isAuthorization = true;
                        this.initByType();
                        this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid, this.apiType);
                        // console.log(this.$route.query.activeName);
                        if (this.$route.query.activeName == undefined) {
                            let allNodes = this.$refs["tree"].store._getAllNodes();
                            this.$refs.tree.setCurrentKey(0);
                            allNodes.forEach(node => {
                                if (node.data.treeNodeId == 0) {
                                    node.expanded = true;
                                }
                            });
                        }

                        return true;
                    }
                } else {
                    this.isAuthorization = false;
                    return false;
                }
            });
        },
        getApiData(getMethodUrl, apiType) {
            if (this.isAuthorization == true) {
                this.isLoading = true;
                this.$axios.get(getMethodUrl)
                    .then(res => {
                        this.dataFormat(res, apiType)
                        this.isLoading = false;
                    })
                    .catch(err => {
                        // console.log(err)
                        this.isLoading = false;
                    })
            } else {
                this.$message({
                    message: '暂无访问权限',
                    type: 'warning',
                    offset: 260,
                });
            }
        },
        dataFormat(formatData, formatType) {
            switch (formatType) {
                case 1: {
                    var resultData = formatData.data.data;
                    let tempTableData = [];
                    if (resultData.length > 0) {
                        resultData.map((val, index) => {
                            var temp = [];
                            temp['researchReportTitle'] = val['Title'];
                            temp['researchReportType'] = val['ClassName'];
                            temp['publishDate'] = val['DisplayTime'];
                            temp['id'] = val['ID'];
                            tempTableData.push(temp);
                        })
                        this.tableData = tempTableData;
                        this.totalRows = formatData.data.count;
                    } else {
                        this.$alert('暂未查询到相关条件下数据', '暂无数据', {
                            confirmButtonText: '确定',
                        });
                        this.tableData = [];
                        this.totalRows = 0;
                    }
                }
                    break;
                case 2: {
                    var resultData = formatData.data.data;
                    let tempTableData = [];
                    if (resultData.length > 0) {
                        resultData.map((val, index) => {
                            var temp = [];
                            temp['researchReportTitle'] = val['Title'];
                            temp['collectionDate'] = val['CreateTime'];
                            temp['researchReportType'] = val['ClassName'];
                            temp['writingDate'] = val['CreateTime']
                            temp['researchReportRatings'] = val['Grade'];
                            temp['researchReportInstitution'] = val['OrganName'][0];
                            temp['researchReportAuthor'] = val['Author'];
                            temp['id'] = val['OrganID'];
                            temp['HtmlPath'] = val['HtmlPath'];
                            temp['stockCode'] = val['StockCode'];
                            temp['companyName'] = val['StockName'];
                            temp['changeStatus'] = val['Vary'];
                            temp['expectedPrice'] = val['AimPrice'];
                            temp['reportClosingPrice'] = val['ClosePrice'];
                            tempTableData.push(temp);
                        })
                        this.tableData = tempTableData;
                        this.totalRows = formatData.data.count;
                    } else {
                        this.tableData = [];
                        this.totalRows = 0;
                    }
                };
                    break;
                case 3: {
                    var resultData = formatData.data.data;
                    let tempTableData = [];
                    if (resultData.length > 0) {
                        resultData.map((val, index) => {
                            var temp = [];
                            temp['Title'] = val['title'];
                            temp['DisplayTime'] = val['createtime'];
                            temp['ClassName'] = val['classname'];
                            temp['id'] = val['id'];
                            temp['keyword'] = val['keyword'];
                            tempTableData.push(temp);
                        })
                        this.tableData = tempTableData;
                        this.totalRows = formatData.data.count;
                    } else {
                        this.tableData = [];
                        this.totalRows = 0;
                    }
                };
                    break;
                case 4: {
                    var resultData = formatData.data.data;
                    let tempTableData = [];
                    if (resultData.length > 0) {
                        resultData.map((val, index) => {
                            var temp = [];
                            temp['ClassName'] = val['ClassName'];
                            temp['Title'] = val['Title'];
                            temp['DisplayTime'] = val['DisplayTime'];
                            temp['StockCode'] = val['StockCode'];
                            temp['keyword'] = val['keys'];
                            temp['id'] = val['ID'];
                            tempTableData.push(temp);
                        })
                        this.tableData = tempTableData;
                        this.totalRows = formatData.data.count;
                    } else {
                        this.tableData = [];
                        this.totalRows = 0;
                    }
                };
                    break;
                case 5: {
                    var resultData = formatData.data.data;
                    let tempTableData = [];
                    if (resultData.length > 0) {
                        let i = (this.currentPage - 1) * 20;
                        resultData.map((val, index) => {
                            i++;
                            var temp = [];
                            temp['stockIndex'] = i;
                            temp['OrganIDCount'] = val['OrganIDCount'];
                            temp['StockCount'] = val['StockCount'];
                            temp['StockCode'] = val['StockCode'];
                            temp['StockName'] = val['StockName'];
                            temp['MaxAimPrice'] = parseFloat(val['MaxAimPrice']).toFixed(2);
                            temp['MinAimPrice'] = parseFloat(val['MinAimPrice']).toFixed(2);
                            temp['ClosePrice'] = parseFloat(val['ClosePrice']).toFixed(2);
                            temp['reportlink'] = '报告链接';
                            tempTableData.push(temp);
                        })
                        this.tableData = tempTableData;
                        this.totalRows = formatData.data.count;
                    } else {
                        this.tableData = [];
                        this.totalRows = 0;
                    }
                };
                    break;
                case 6: {
                    var resultData = formatData.data.data;
                    let tempTableData = [];
                    if (resultData.length > 0) {
                        resultData.map((val, index) => {
                            var temp = [];
                            temp['OrganIDCount'] = val['OrganIDCount'];
                            temp['StockCount'] = val['StockCount'];
                            temp['StockCode'] = val['StockCode'];
                            temp['StockName'] = val['StockName'];
                            temp['MaxAimPrice'] = parseFloat(val['MaxAimPrice']).toFixed(2);
                            temp['MinAimPrice'] = parseFloat(val['MinAimPrice']).toFixed(2);
                            temp['ClosePrice'] = parseFloat(val['ClosePrice']).toFixed(2);
                            temp['MaxOriginGrade'] = val['MaxOriginGrade'];
                            temp['MinOriginGrade'] = val['MinOriginGrade'];
                            temp['reportlink'] = '报告链接';
                            tempTableData.push(temp);
                        })
                        this.tableData = tempTableData;
                        this.totalRows = parseInt(formatData.data.count);
                    } else {
                        this.tableData = [];
                        this.totalRows = 0;
                    }
                };
                    break;
                case 7: {
                    var resultData = formatData.data.data;
                    let tempTableData = [];
                    if (resultData.length > 0) {
                        resultData.map((val, index) => {
                            var temp = [];
                            temp['OrganName'] = val['OrganName'];
                            temp['ContentCount'] = val['ContentCount'];
                            temp['AuthorCount'] = val['AuthorCount'];
                            temp['avgCount'] = parseFloat(val['ContentCount'] / val['AuthorCount']).toFixed(0);
                            temp['StockCodeCount'] = val['StockCodeCount'];
                            temp['Count732'] = val['Count732'];
                            temp['Count557'] = val['Count557'];
                            temp['Count559'] = val['Count559'];
                            tempTableData.push(temp);
                        })
                        this.tableData = tempTableData;
                        this.totalRows = parseInt(formatData.data.count);
                    } else {
                        this.tableData = [];
                        this.totalRows = 0;
                    }
                };
                    break;
                default:
                  // console.log(this.totalRows);
                    break;
            }
        },
        onDetail(row) {
            // console.log(this.apiType);
            if (this.apiType == 1) {
                this.$router.push({ path: '/articleDetailTwo', query: { url: 'http://tg.bolanjr.com/api/api/getContent', id: row['id'], apiType: 1, cate: 'library' } })
            } else if (this.apiType == 2) {
                window.open(row.HtmlPath);
            } else if (this.apiType == 3) {
                this.$router.push({ path: '/articleDetailTwo', query: { url: 'http://tg.bolanjr.com/api/api/zjdxDetail', id: row['id'], zqcode: this.currentCatid, apiType: 3, cate: 'library' } })
            }
            else if (this.apiType == 4) {
                this.$router.push({ path: '/articleDetailTwo', query: { url: 'http://tg.bolanjr.com/api/api/zqwxDetail', id: row['id'], zqcode: this.currentCatid, apiType: 4, cate: 'library' } })
            }
        },
        handleNodeClick(data) {
            this.expandAllNodes(data);
            this.currentPage = 1;
            if (data.hasOwnProperty('catid')) {
                this.currentCatid = data['catid'];
                this.isFinancialEspionageOnline = true;
                this.apiType = 1;
                this.currentUrlHead = 'http://tg.bolanjr.com/api/api/jrdbOnline?page=';
                this.currentUrlfooter = '&limit=20&catid=';
                this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid, this.apiType);
            } else if (data.hasOwnProperty('classId')) {
                this.currentCatid = data['classId'];
                if (this.currentCatid == 'A001') {
                    this.isFinancialEspionageOnline = false;
                    this.apiType = 5;
                    this.researchReportCollectionDateRangesTemp = this.researchReportCollectionDateRangesTypeTwo;
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/dhyb/getZsgzgpList?page=';
                    this.currentUrlfooter = '&limit=20&time2=5';
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter, this.apiType);
                } else if (this.currentCatid == 'A002') {
                    this.isFinancialEspionageOnline = false;
                    this.apiType = 6;
                    this.researchReportCollectionDateRangesTemp = this.researchReportCollectionDateRangesTypeThree;
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/dhyb/getGgpjdqList?page=';
                    this.currentUrlfooter = '&limit=20&time1=90';
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter, this.apiType);
                } else if (this.currentCatid == 'A003') {
                    this.isFinancialEspionageOnline = false;
                    this.apiType = 7;
                    this.researchReportCollectionDateRangesTemp = this.researchReportCollectionDateRangesTypeThree;
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/dhyb/getJgybtjList?page=';
                    this.currentUrlfooter = '&limit=20&time1=90';
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter, this.apiType);
                } else {
                    this.isFinancialEspionageOnline = false;
                    this.currentType = data['type']
                    this.apiType = 2;
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/dhyb/getList?page=';
                    this.currentUrlfooter = '&limit=20&type=' + this.currentType + '&classId=';
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid, this.apiType);
                }
            } else if (data.hasOwnProperty('zqcode')) {
                if (data.label == '资金') {
                    this.currentCatid = data['zqcode'];
                    this.isFinancialEspionageOnline = false;
                    this.apiType = 3;
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/api/zjdxList?page=';
                    this.currentUrlfooter = '&limit=20&zqcode=';
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid, this.apiType);
                } else {
                    this.currentCatid = data['zqcode'];
                    this.isFinancialEspionageOnline = false;
                    this.apiType = 4;
                    this.currentUrlHead = 'http://tg.bolanjr.com/api/api/zqwxList?page=';
                    this.currentUrlfooter = '&limit=20&zqcode=';
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid, this.apiType);
                }

            } else {
                var choseNodeName = '';
                choseNodeName = data['__ob__']['value']['label'];
                switch (choseNodeName) {
                    case "数据中心":
                      // console.log(choseNodeName);
                        window.open('https://dfzq.bolanjr.com/bolaninfo/');
                        break;
                }
            }
        },
        onRefresh() {
            this.collectionDateRangeTypeTwo = '';
            this.serachCondition = '';
            this.dateRangeCondition = '';
            this.collectionDateRange = '';
            this.stockCodeCondition = '';
            this.stockNameCondition = '';
            this.researchReportTitle = '';
            this.researchReportRatingsValue = '';
            this.researchReportInstitution = '';
            this.researchReportAuthor = '';
            this.industryCondition = '';
            this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid, this.apiType);
            // console.log('clear condition');
        },
        expandAllNodes(data) {
            let allNodes = this.$refs["tree"].store._getAllNodes();
            let tempNodeArr = [];
            let tempNode = [];
            allNodes.forEach(node => {
                if (node.childNodes.length > 0) {
                    tempNodeArr.push(node);
                }
                if (node.data.treeNodeId == data.treeNodeId) {
                    node.expanded = true;
                    tempNode = node;
                } else {
                    node.expanded = false;
                }
            });
            this.NodeExpand(tempNodeArr, tempNode);
        },
        NodeExpand(tempNodeArr, Node) {
            let NextNode = [];
            tempNodeArr.map((val) => {
                if (val.childNodes.includes(Node)) {
                    NextNode = val;
                    NextNode.expanded = true;
                    tempNodeArr.pop(val);
                    this.NodeExpand(tempNodeArr, NextNode);
                };
            })
        },
        onSearch() {
            this.currentPage = 1;
            var dataRange = ''
            if (this.dateRangeCondition.length > 0) {
                dataRange = this.dateRangeCondition[0] + ' 00:00:00 - ' + this.dateRangeCondition[1] + ' 00:00:00';
            }
            switch (this.currentCatid) {
                case 'C945': {
                    this.serachCondition = '&author=' + this.researchReportAuthor.substring(0, 20) + '&createTime=' + this.collectionDateRange + '&grade=' + this.researchReportRatingsValue
                        + '&organ=' + this.researchReportInstitution + '&stockCode=' + this.stockCodeCondition.substring(0, 10) + '&stockName=' + this.stockNameCondition.substring(0, 100) + '&title='
                        + this.researchReportTitle.substring(0, 200) + '&trade=' + this.industryCondition + '&reportTimeSelect=&time1=90&time2=5'
                    this.apiType = 2;
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid + this.serachCondition, this.apiType);
                }
                    break;
                case 'A001': {
                    this.currentUrlfooter = '&limit=20';
                    this.serachCondition = '&time1=90&time2=' + this.collectionDateRange;
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.serachCondition, this.apiType);
                }
                    break;
                case 'A002': {
                    this.currentUrlfooter = '&limit=20';
                    this.serachCondition = '&time2=90&time1=' + this.collectionDateRange;
                    // console.log(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.serachCondition, this.apiType);
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.serachCondition, this.apiType);
                }
                    break;
                case 'A003': {
                    this.currentUrlfooter = '&limit=20';
                    this.serachCondition = '&time2=90&time1=' + this.collectionDateRange;
                    // console.log(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.serachCondition, this.apiType);
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.serachCondition, this.apiType);
                }
                    break;
                default: {
                    this.serachCondition = '&author=' + this.researchReportAuthor.substring(0, 20) + '&createTime=' + this.collectionDateRange + '&grade=' + this.researchReportRatingsValue
                        + '&organ=' + this.researchReportInstitution + '&stockCode=' + this.stockCodeCondition.substring(0, 10) + '&stockName=' + this.stockNameCondition.substring(0, 100) + '&title='
                        + this.researchReportTitle.substring(0, 200) + '&trade=' + this.industryCondition + '&reportTimeSelect=' + dataRange + '&keyword=' + this.keywordCondition;
                    this.getApiData(this.currentUrlHead + this.currentPage + this.currentUrlfooter + this.currentCatid + this.serachCondition, this.apiType);
                }
                    break;
            }

        }
    },
    data() {
        return {
            isAuthorization: false,
            tableDataTypeOne: ['C1263', 'C735', 'C559', 'C557', 'C558', 'C734', 'C5481', 'C737', 'C738', 'C810', 'C984', 'C1000', 'C4515', 'C5488', 'C5489', 'C732'],
            tableDataTypeTwo: ['C731', 'C945', 'C560', 'C3954'],
            arrSearchConditionOne: ['C1263'],
            arrSearchConditionTwo: [],
            arrSearchConditionThree: ['C735', 'C559', 'C557', 'C558', 'C734', 'C5481', 'C737', 'C738', 'C810', 'C984', 'C1000', 'C4515', 'C5488', 'C5489'],
            arrSearchConditionFour: ['A001'],
            arrSearchConditionFive: ['A002', 'A003'],
            arrSearchConditionSix: ['C731', 'C945', 'C560', 'C3954'],
            arrSearchConditionSeven: ['C732'],
            arrSecuritiesMicroLibrary: ['WX001', 'WX002', 'WX003', 'WX004', 'WX005', 'WX006', 'WX007', 'DX001'],
            disableChar: true,
            industryCondition: '',
            isLoading: false,
            serachCondition: '',
            isFinancialEspionageOnline: false,
            keywordCondition: '',
            stockCodeCondition: '',
            stockNameCondition: '',
            dateRangeCondition: '',
            totalRows: 1000,
            apiType: 2,
            currentType: 1,
            currentUrlHead: 'http://tg.bolanjr.com/api/dhyb/getList?page=',
            currentUrlfooter: '&limit=20&type=1&classId=',
            currentCatid: 'C1263',
            currentPage: 1,
            leftListData: [
                {
                    label: '大行研报库',
                    treeNodeId: 0,
                    children: [{
                        label: '最新报告',
                        classId: 'C1263',
                        type: 1,
                        treeNodeId: 1,
                    }, {
                        label: '个股评级',
                        classId: 'C731',
                        type: 2,
                        treeNodeId: 2,
                    }, {
                        label: '机构晨报',
                        classId: 'C735',
                        type: 3,
                        treeNodeId: 3,
                    }, {
                        label: '机构策略',
                        classId: 'C559',
                        type: 3,
                        treeNodeId: 4,
                    }, {
                        label: '新股研报',
                        classId: 'C945',
                        type: 2,
                        treeNodeId: 5,
                    }, {
                        label: '宏观经济',
                        classId: 'C557',
                        type: 3,
                        treeNodeId: 6,
                    }, {
                        label: '政策评析',
                        classId: 'C558',
                        type: 3,
                        treeNodeId: 7,
                    }, {
                        label: '基金报告',
                        classId: 'C734',
                        type: 3,
                        treeNodeId: 8,
                    }, {
                        label: '港股研报',
                        classId: 'C560',
                        type: 2,
                        treeNodeId: 9,
                    }, {
                        label: '香港市场报告',
                        classId: 'C5481',
                        type: 3,
                        treeNodeId: 10,
                    }, {
                        label: '股指期货',
                        classId: 'C737',
                        type: 3,
                        treeNodeId: 11,
                    }, {
                        label: '债券研报',
                        classId: 'C738',
                        type: 3,
                        treeNodeId: 12,
                    }, {
                        label: '海外市场',
                        classId: 'C810',
                        type: 3,
                        treeNodeId: 13,
                    }, {
                        label: '权证市场',
                        classId: 'C984',
                        type: 3,
                        treeNodeId: 14,
                    }, {
                        label: '衍生工具',
                        classId: 'C1000',
                        type: 3,
                        treeNodeId: 15,
                    }, {
                        label: '创业板',
                        classId: 'C3954',
                        type: 2,
                        treeNodeId: 16,
                    }, {
                        label: '融资融券',
                        classId: 'C4515',
                        type: 3,
                        treeNodeId: 17,
                    }, {
                        label: '期权研究',
                        classId: 'C5488',
                        type: 3,
                        treeNodeId: 18,
                    }, {
                        label: '新三板',
                        classId: 'C5489',
                        type: 3,
                        treeNodeId: 19,
                    }, {
                        label: '行业报告',
                        classId: 'C732',
                        type: 4,
                        treeNodeId: 20,
                    }, {
                        label: '最受机构关注股票',
                        classId: 'A001',
                        type: 101,
                        treeNodeId: 21,
                    }, {
                        label: '个股评级大全',
                        classId: 'A002',
                        type: 102,
                        treeNodeId: 22,
                    }, {
                        label: '机构研报统计',
                        classId: 'A003',
                        type: 103,
                        treeNodeId: 23,
                    },
                    ]
                },/* {
                    label: '金融谍报在线',
                    treeNodeId: 24,
                    children: [{
                        label: '今日要闻',
                        catid: 'C2812',
                        treeNodeId: 1000,
                    }, {
                        label: '盘面直通车',
                        catid: 'C3859',
                        treeNodeId: 25,
                        children: [{
                            label: '盘前半小时',
                            catid: 'C3860',
                            treeNodeId: 26,
                            children: [{
                                label: '今日提示',
                                catid: 'C3861',
                                treeNodeId: 27,
                            }, {
                                label: '今日公告',
                                catid: 'C4220',
                                treeNodeId: 28,
                            }, {
                                label: '新股提示',
                                catid: 'C3862',
                                treeNodeId: 29,
                            }, {
                                label: '早闻解读',
                                catid: 'C3863',
                                treeNodeId: 30,
                            }, {
                                label: '晨报聚焦',
                                catid: 'C3865',
                                treeNodeId: 31,
                            }, {
                                label: '大牌个股',
                                catid: 'C3866',
                                treeNodeId: 32,
                            }, {
                                label: '外围市场',
                                catid: 'C3864',
                                treeNodeId: 33,
                            }, {
                                label: '昨日数据',
                                catid: 'C3867',
                                treeNodeId: 34,
                            },
                            ],
                        }, {
                            label: '盘中整点',
                            catid: 'C3868',
                            treeNodeId: 35,

                            children: [{
                                label: '盘面直击',
                                catid: 'C3870',
                                treeNodeId: 36,
                            }, {
                                label: '虎踞龙盘',
                                catid: 'C3871',
                                treeNodeId: 37,
                            }, {
                                label: '午间小憩',
                                catid: 'C3872',
                                treeNodeId: 38,
                            }, {
                                label: '上午数据',
                                catid: 'C3873',
                                treeNodeId: 39,
                            }, {
                                label: '新闻直通',
                                catid: 'C3869',
                                treeNodeId: 40,
                            },
                            ],
                        }, {
                            label: '盘后解疑',
                            catid: 'C3874',
                            treeNodeId: 41,
                            children: [{
                                label: '盘后综述',
                                catid: 'C3875',
                                treeNodeId: 42,
                            }, {
                                label: '盘后新闻',
                                catid: 'C3876',
                                treeNodeId: 43,
                            }, {
                                label: '盘后数据',
                                catid: 'C3877',
                                treeNodeId: 44,
                            },
                            ],
                        },
                        ],
                    }, {
                        label: '证券要情',
                        catid: 'C368',
                        treeNodeId: 45,
                    }, {
                        label: '经济情报',
                        catid: 'C369',
                        treeNodeId: 46,
                        children: [{
                            label: '国外经济',
                            catid: 'C2512',
                            treeNodeId: 47,
                        }, {
                            label: '国内经济',
                            catid: 'C2493',
                            treeNodeId: 48,
                        },
                        ],
                    }, {
                        label: '融资融券',
                        catid: 'C4507',
                        treeNodeId: 49,
                    }, {
                        label: '机构决策',
                        catid: 'C426',
                        treeNodeId: 50,
                        children: [{
                            label: '趋势',
                            catid: 'C427',
                            treeNodeId: 51,
                        }, {
                            label: '热点',
                            catid: 'C429',
                            treeNodeId: 52,
                        },
                        ],
                    }, {
                        label: '机构晨报',
                        catid: 'C2815',
                        treeNodeId: 53,
                    },
                    {
                        label: '个股异动',
                        catid: 'C2817',
                        treeNodeId: 54,
                    }, {
                        label: '交易数据',
                        catid: 'C3518',
                        treeNodeId: 55,
                        children: [{
                            label: '机构动向',
                            catid: 'C3786',
                            treeNodeId: 56,
                        }, {
                            label: '散户动向',
                            catid: 'C3787',
                            treeNodeId: 57,
                        }, {
                            label: '机构资金',
                            catid: 'C3788',
                            treeNodeId: 58,
                        }, {
                            label: '散户资金',
                            catid: 'C3789',
                            treeNodeId: 59,
                        }, {
                            label: '行业资金',
                            catid: 'C3691',
                            treeNodeId: 60,
                        },
                        ],
                    },
                    {
                        label: '个股评级',
                        catid: 'C481',
                        treeNodeId: 61,
                        children: [{
                            label: '推荐',
                            catid: 'C482',
                            treeNodeId: 62,
                        }, {
                            label: '增持',
                            catid: 'C483',
                            treeNodeId: 63,
                        }, {
                            label: '买入',
                            catid: 'C773',
                            treeNodeId: 64,
                        }, {
                            label: '减持',
                            catid: 'C778',
                            treeNodeId: 65,
                        }, {
                            label: '中性',
                            catid: 'C777',
                            treeNodeId: 66,
                        }, {
                            label: '持有',
                            catid: 'C484',
                            treeNodeId: 67,
                        }, {
                            label: '卖出',
                            catid: 'C2820',
                            treeNodeId: 68,
                        }, {
                            label: '无评级',
                            catid: 'C820',
                            treeNodeId: 69,
                        },
                        ],
                    }, {
                        label: '公司情报',
                        catid: 'C487',
                        treeNodeId: 70,
                        children: [{
                            label: '公司情报',
                            catid: 'C487',
                            treeNodeId: 71,
                        }, {
                            label: '交易提示',
                            catid: 'C2523',
                            treeNodeId: 72,
                        }, {
                            label: '澄清公告',
                            catid: 'C2823',
                            treeNodeId: 73,
                        }, {
                            label: '风险异常',
                            catid: 'C2824',
                            treeNodeId: 74,
                        }, {
                            label: '停市复牌',
                            catid: 'C2532',
                            treeNodeId: 75,
                        }, {
                            label: '重大消息',
                            catid: 'C2534',
                            treeNodeId: 76,
                        }, {
                            label: '资产重组',
                            catid: 'C2526',
                            treeNodeId: 77,
                        }, {
                            label: '关联交易',
                            catid: 'C2825',
                            treeNodeId: 78,
                        }, {
                            label: '担保贷款',
                            catid: 'C2528',
                            treeNodeId: 79,
                        }, {
                            label: '质押诉讼',
                            catid: 'C2826',
                            treeNodeId: 80,
                        }, {
                            label: '大小非减持',
                            catid: 'C2827',
                            treeNodeId: 81,
                        }, {
                            label: '股东大会',
                            catid: 'C2525',
                            treeNodeId: 82,
                        }, {
                            label: '股权变动',
                            catid: 'C2533',
                            treeNodeId: 83,
                        }, {
                            label: '股权激励',
                            catid: 'C2527',
                            treeNodeId: 84,
                        }, {
                            label: '股本变动',
                            catid: 'C2829',
                            treeNodeId: 85,
                        }, {
                            label: '高管变动',
                            catid: 'C2531',
                            treeNodeId: 86,
                        }, {
                            label: '政策影响',
                            catid: 'C2530',
                            treeNodeId: 87,
                        }, {
                            label: '证券投资',
                            catid: 'C2539',
                            treeNodeId: 88,
                        }, {
                            label: '实业投资',
                            catid: 'C2538',
                            treeNodeId: 89,
                        }, {
                            label: '大笔订单',
                            catid: 'C2529',
                            treeNodeId: 90,
                        }, {
                            label: '品牌铸造',
                            catid: 'C2536',
                            treeNodeId: 91,
                        }, {
                            label: '其它情报',
                            catid: 'C2830',
                            treeNodeId: 92,
                        },
                        ],
                    }, {
                        label: '业绩通道',
                        catid: 'C491',
                        treeNodeId: 93,
                        children: [{
                            label: '财报',
                            catid: 'C2831',
                            treeNodeId: 94,
                        }, {
                            label: '预报',
                            catid: 'C2832',
                            treeNodeId: 95,
                            children: [{
                                label: '预增',
                                catid: 'C2834',
                                treeNodeId: 96,
                            }, {
                                label: '预盈',
                                catid: 'C2835',
                                treeNodeId: 97,
                            }, {
                                label: '预降',
                                catid: 'C2836',
                                treeNodeId: 98,
                            }, {
                                label: '预亏',
                                catid: 'C2837',
                                treeNodeId: 99,
                            }, {
                                label: '预平',
                                catid: 'C2838',
                                treeNodeId: 100,
                            }, {
                                label: '预警',
                                catid: 'C2839',
                                treeNodeId: 101,
                            }, {
                                label: '减亏',
                                catid: 'C2840',
                                treeNodeId: 102,
                            }, {
                                label: '增亏',
                                catid: 'C2841',
                                treeNodeId: 103,
                            }, {
                                label: '续亏',
                                catid: 'C2842',
                                treeNodeId: 104,
                            }, {
                                label: '其他',
                                catid: 'C2843',
                                treeNodeId: 105,
                            },
                            ]
                        },
                        ],
                    }, {
                        label: '直接融资',
                        catid: 'C2844',
                        treeNodeId: 106,
                        children: [{
                            label: '融资要情',
                            catid: 'C2845',
                            treeNodeId: 107,
                        }, {
                            label: '发审委公告',
                            catid: 'C2846',
                            treeNodeId: 108,
                        }, {
                            label: '再融资',
                            catid: 'C2847',
                            treeNodeId: 109,
                        }, {
                            label: '发行上市公告',
                            catid: 'C2848',
                            treeNodeId: 110,
                        }, {
                            label: '新股点评',
                            catid: 'C2849',
                            treeNodeId: 111,
                        }, {
                            label: '新股上市定价',
                            catid: 'C2850',
                            treeNodeId: 112,
                        }, {
                            label: '新股申购中签',
                            catid: 'C2851',
                            treeNodeId: 113,
                        },
                        ],
                    }, {
                        label: '基金全景',
                        catid: 'C498',
                        treeNodeId: 114,
                    }, {
                        label: '香港股情',
                        catid: 'C503',
                        treeNodeId: 115,
                    }, {
                        label: '行业研究',
                        catid: 'C445',
                        treeNodeId: 116,
                        children: [{
                            label: '金融行业',
                            catid: 'C134',
                            treeNodeId: 117,
                            children: [
                                {
                                    label: '多元金融',
                                    catid: 'C138',
                                    treeNodeId: 118,
                                }, {
                                    label: '保险业',
                                    catid: 'C137',
                                    treeNodeId: 119,
                                }, {
                                    label: '证券期货',
                                    catid: 'C136',
                                    treeNodeId: 120,
                                }, {
                                    label: '银行业',
                                    catid: 'C135',
                                    treeNodeId: 121,
                                },],
                        }, {
                            label: '石油行业',
                            catid: 'C71',
                            treeNodeId: 122,
                            children: [
                                {
                                    label: '石油开采',
                                    catid: 'C1142',
                                    treeNodeId: 123,
                                }, {
                                    label: '石油加工',
                                    catid: 'C1141',
                                    treeNodeId: 124,
                                },],
                        }, {
                            label: '煤炭开采',
                            catid: 'C58',
                            treeNodeId: 125,
                        }, {
                            label: '电力行业',
                            catid: 'C105',
                            treeNodeId: 126,
                        }, {
                            label: '房地产业',
                            catid: 'C139',
                            treeNodeId: 127,
                            children: [
                                {
                                    label: '房产开发',
                                    catid: 'C1143',
                                    treeNodeId: 128,
                                },],
                        }, {
                            label: '商业贸易',
                            catid: 'C129',
                            treeNodeId: 129,
                            children: [
                                {
                                    label: '贸易综合',
                                    catid: 'C132',
                                    treeNodeId: 130,
                                }, {
                                    label: '零售业',
                                    catid: 'C131',
                                    treeNodeId: 131,
                                },],
                        }, {
                            label: '供水供气',
                            catid: 'C107',
                            treeNodeId: 132,
                            children: [
                                {
                                    label: '供气',
                                    catid: 'C108',
                                    treeNodeId: 133,
                                }, {
                                    label: '供水',
                                    catid: 'C109',
                                    treeNodeId: 134,
                                },],
                        }, {
                            label: '钢铁行业',
                            catid: 'C59',
                            treeNodeId: 135,
                        }, {
                            label: '有色行业',
                            catid: 'C61',
                            treeNodeId: 136,
                            children: [
                                {
                                    label: '有色冶炼',
                                    catid: 'C719',
                                    treeNodeId: 137,
                                }, {
                                    label: '有色矿采',
                                    catid: 'C62',
                                    treeNodeId: 138,
                                },],
                        },
                        {
                            label: '电子信息',
                            catid: 'C123',
                            treeNodeId: 139,
                            children: [
                                {
                                    label: '计算机',
                                    catid: 'C125',
                                    treeNodeId: 140,
                                }, {
                                    label: '电子器件',
                                    catid: 'C126',
                                    treeNodeId: 141,
                                }, {
                                    label: '软件业',
                                    catid: 'C128',
                                    treeNodeId: 142,
                                }, {
                                    label: '通信设备',
                                    catid: 'C124',
                                    treeNodeId: 143,
                                }, {
                                    label: '通信服务',
                                    catid: 'C1151',
                                    treeNodeId: 144,
                                },],
                        }, {
                            label: '化工行业',
                            catid: 'C72',
                            treeNodeId: 145,
                        }, {
                            label: '机械行业',
                            catid: 'C91',
                            treeNodeId: 146,
                            children: [
                                {
                                    label: '专业机械',
                                    catid: 'C92',
                                    treeNodeId: 147,
                                }, {
                                    label: '电气机械',
                                    catid: 'C93',
                                    treeNodeId: 148,
                                }, {
                                    label: '通用机械',
                                    catid: 'C713',
                                    treeNodeId: 149,
                                }, {
                                    label: '船舶业',
                                    catid: 'C1030',
                                    treeNodeId: 150,
                                },],
                        }, {
                            label: '仪器仪表',
                            catid: 'C96',
                            treeNodeId: 151,
                        }, {
                            label: '航空行业',
                            catid: 'C102',
                            treeNodeId: 152,
                        }, {
                            label: '交通运输',
                            catid: 'C103',
                            treeNodeId: 153,
                            children: [
                                {
                                    label: '水上运输',
                                    catid: 'C119',
                                    treeNodeId: 154,
                                }, {
                                    label: '高速公路',
                                    catid: 'C117',
                                    treeNodeId: 155,
                                }, {
                                    label: '铁路运输',
                                    catid: 'C116',
                                    treeNodeId: 156,
                                }, {
                                    label: '物流管理',
                                    catid: 'C122',
                                    treeNodeId: 157,
                                }, {
                                    label: '航空运输',
                                    catid: 'C121',
                                    treeNodeId: 158,
                                }, {
                                    label: '港口',
                                    catid: 'C120',
                                    treeNodeId: 159,
                                }, {
                                    label: '运输设备',
                                    catid: 'C104',
                                    treeNodeId: 160,
                                },],
                        }, {
                            label: '家电行业',
                            catid: 'C1146',
                            treeNodeId: 161,
                        }, {
                            label: '酒店旅游',
                            catid: 'C141',
                            treeNodeId: 162,
                            children: [
                                {
                                    label: '旅游景区',
                                    catid: 'C144',
                                    treeNodeId: 163,
                                }, {
                                    label: '旅游饭店',
                                    catid: 'C142',
                                    treeNodeId: 164,
                                },],
                        }, {
                            label: '农林牧渔',
                            catid: 'C53',
                            treeNodeId: 165,
                            children: [
                                {
                                    label: '种植',
                                    catid: 'C54',
                                    treeNodeId: 166,
                                }, {
                                    label: '畜牧',
                                    catid: 'C56',
                                    treeNodeId: 167,
                                },],
                        }, {
                            label: '食品饮料',
                            catid: 'C63',
                            treeNodeId: 168,
                        }, {
                            label: '酿酒行业',
                            catid: 'C64',
                            treeNodeId: 169,
                        }, {
                            label: '农药化肥',
                            catid: 'C73',
                            treeNodeId: 170,
                        }, {
                            label: '纺织行业',
                            catid: 'C65',
                            treeNodeId: 171,
                            children: [
                                {
                                    label: '服装鞋类',
                                    catid: 'C67',
                                    treeNodeId: 172,
                                }, {
                                    label: '纺织印染',
                                    catid: 'C66',
                                    treeNodeId: 173,
                                }, {
                                    label: '纺织机械',
                                    catid: 'C716',
                                    treeNodeId: 174,
                                },],
                        }, {
                            label: '家具行业',
                            catid: 'C68',
                            treeNodeId: 175,
                        }, {
                            label: '化纤行业',
                            catid: 'C74',
                            treeNodeId: 176,
                        }, {
                            label: '生物医药',
                            catid: 'C87',
                            treeNodeId: 177,
                            children: [
                                {
                                    label: '医疗器械',
                                    catid: 'C88',
                                    treeNodeId: 178,
                                }, {
                                    label: '医药制造',
                                    catid: 'C1147',
                                    treeNodeId: 179,
                                },],
                        }, {
                            label: '建筑建材',
                            catid: 'C113',
                            treeNodeId: 180,
                            children: [
                                {
                                    label: '土木工程',
                                    catid: 'C751',
                                    treeNodeId: 181,
                                }, {
                                    label: '建材产品',
                                    catid: 'C1149',
                                    treeNodeId: 182,
                                },],
                        }, {
                            label: '水泥行业',
                            catid: 'C77',
                            treeNodeId: 183,
                        }, {
                            label: '玻璃陶瓷',
                            catid: 'C78',
                            treeNodeId: 184,
                        }, {
                            label: '造纸行业',
                            catid: 'C69',
                            treeNodeId: 185,
                        }, {
                            label: '印刷包装',
                            catid: 'C70',
                            treeNodeId: 186,
                        }, {
                            label: '环保节能',
                            catid: 'C89',
                            treeNodeId: 187,
                            children: [
                                {
                                    label: '环保机械',
                                    catid: 'C90',
                                    treeNodeId: 188,
                                },],
                        }, {
                            label: '文化传媒',
                            catid: 'C145',
                            treeNodeId: 189,
                        }, {
                            label: '综合类',
                            catid: 'C146',
                            treeNodeId: 190,
                        }, {
                            label: '交运设备',
                            catid: 'C5422',
                            treeNodeId: 191,
                        },
                        ],
                    },]
                }, {
                    label: '证券微讯库',
                    treeNodeId: 192,
                    children: [{
                        label: '要情',
                        zqcode: 'WX001',
                        treeNodeId: 193,
                    }, {
                        label: '个股',
                        zqcode: 'WX002',
                        treeNodeId: 194,
                    }, {
                        label: '策略',
                        zqcode: 'WX003',
                        treeNodeId: 195,
                    }, {
                        label: '基金',
                        zqcode: 'WX004',
                        treeNodeId: 196,
                    }, {
                        label: '内参',
                        zqcode: 'WX005',
                        treeNodeId: 197,
                    }, {
                        label: '公告',
                        zqcode: 'WX006',
                        treeNodeId: 198,
                    }, {
                        label: '行业',
                        zqcode: 'WX007',
                        treeNodeId: 199,
                    }, {
                        label: '资金',
                        zqcode: 'DX001',
                        treeNodeId: 200,
                    },
                    ]
                },*/ {
                    label: '数据中心',
                }],
            leftDefaultProps: {
                children: 'children',
                label: 'label'
            },
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },

            researchReportTitle: '',
            researchReportInstitution: '',
            researchReportAuthor: '',
            tableData: [{
            },],

            researchReportRatings: [{
                researchReportRatingsValue: '0',
                researchReportRatingsLabel: '无评级'
            }, {
                researchReportRatingsValue: 'A',
                researchReportRatingsLabel: '推荐'
            }
                , {
                researchReportRatingsValue: 'B',
                researchReportRatingsLabel: '增持'
            }, {
                researchReportRatingsValue: 'C',
                researchReportRatingsLabel: '维持'
            }, {
                researchReportRatingsValue: 'E',
                researchReportRatingsLabel: '买入'
            }, {
                researchReportRatingsValue: 'G',
                researchReportRatingsLabel: '中性'
            }, {
                researchReportRatingsValue: 'H',
                researchReportRatingsLabel: '减持'
            }],
            researchReportRatingsValue: '',

            researchReportCollectionDateRanges: [{
                collectionDateRange: '0',
                collectionDateRangeLabel: '今天'
            }, {
                collectionDateRange: '1',
                collectionDateRangeLabel: '最近三天'
            }
                , {
                collectionDateRange: '2',
                collectionDateRangeLabel: '最近一周'
            }, {
                collectionDateRange: '3',
                collectionDateRangeLabel: '最近一个月'
            }, {
                collectionDateRange: '4',
                collectionDateRangeLabel: '最近三个月'
            }, {
                collectionDateRange: '5',
                collectionDateRangeLabel: '最近半年'
            }, {
                collectionDateRange: '6',
                collectionDateRangeLabel: '最近一年'
            }],
            researchReportCollectionDateRangesTemp: [],
            researchReportCollectionDateRangesTypeTwo: [{
                collectionDateRange: '5',
                collectionDateRangeLabel: '最近5天'
            }, {
                collectionDateRange: '15',
                collectionDateRangeLabel: '最近15天'
            }
                , {
                collectionDateRange: '30',
                collectionDateRangeLabel: '最近一个月'
            }, {
                collectionDateRange: '90',
                collectionDateRangeLabel: '最近三个月'
            },],

            researchReportCollectionDateRangesTypeThree: [{
                collectionDateRange: '90',
                collectionDateRangeLabel: '最近三个月'
            }, {
                collectionDateRange: '180',
                collectionDateRangeLabel: '最近半年'
            }
                , {
                collectionDateRange: '365',
                collectionDateRangeLabel: '最近一年'
            },],

            collectionDateRange: '',
        };

    },
};
</script>



// WEBPACK FOOTER //
// src/components/InvestmentResearchLibrary.vue